import {createSetNodeAttributeCommand} from "./createSetNodeAttributeCommand";


export const setTypeInfo = createSetNodeAttributeCommand('type', 'info');
export const setTypeWarning = createSetNodeAttributeCommand('type', 'warning');
export const setTypeDanger = createSetNodeAttributeCommand('type', 'danger');
export const setTypeSuccess = createSetNodeAttributeCommand('type', 'success');
